/*
  Функция pluralize ищет индекс для формы слова вида
    Подписка/Подписки/Подписок
  Индексы:
    0 - подходит для любого количества, оканчивающегося на 1, кроме 11
    1 - подходит для любого количества, оканчивающегося на 2/3/4
    2 - подходит для любого количества, оканчивающегося на 5/6/7/8/9/0/11..19
*/
export const pluralize = (amount: number, words: string[]): string => {
  const lastTwoNumbers = amount % 100
  const lastNumber = amount % 10
  let wordIndex: number

  if (lastTwoNumbers >= 11 && lastTwoNumbers <= 19) {
    wordIndex = 2
    return words[wordIndex]
  }

  switch (lastNumber) {
    case 1:
      wordIndex = 0
      break
    case 2:
    case 3:
    case 4:
      wordIndex = 1
      break
    default:
      wordIndex = 2
  }
  return words[wordIndex]
}
